import { ImportConfigurationDTO, ImportConfigurationTransferType, ImportType, NavisionImportTemplate } from "src/app/base/models/models.swagger.generated";

export function getNavisionTempalteIcon(config: ImportConfigurationDTO): string {
  let template = config.fileConfig?.navisionImportTemplate;
  if (config.transferType == ImportConfigurationTransferType.Acodis || config.importType == ImportType.Parashift) {
    template = NavisionImportTemplate.Pdf;
  }
  else if (config.transferType == ImportConfigurationTransferType.Magento) {
    template = NavisionImportTemplate.Web;
  }
  else if (config.transferType == ImportConfigurationTransferType.Zir) {
    template = NavisionImportTemplate.Web;
  }

  switch (template) {
    case NavisionImportTemplate.Excel:
      return 'icon-XLS';
    case NavisionImportTemplate.Pdf:
      return 'icon-PDF';
    case NavisionImportTemplate.Web:
      return 'icon-application--web';
    case NavisionImportTemplate.Xml:
      return 'icon-XML';
    default:
      return '';
  }
}